import React, { FC } from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Divider, ListItemIcon, Typography } from '@mui/material'
import { Check, ArrowDropDown, NotificationsOffOutlined, Notifications } from '@mui/icons-material'
import { TopicEmailSubscriptionPeriod } from '../../models/topicEmailSubscriptionPeriod'

type EmailSubscriptionMenuProps = {
  selectedPeriod?: TopicEmailSubscriptionPeriod
  onSubscribeTopicEmails: (period: TopicEmailSubscriptionPeriod) => Promise<void>
}

const options: Array<{ period: TopicEmailSubscriptionPeriod; value: string }> = [
  { period: null, value: 'No emails, please' },
  { period: 'IMMEDIATELY', value: 'Immediately' },
  { period: 'EVERY_FIFTEEN_MINUTES', value: 'Every 15 minutes' },
  { period: 'EVERY_HOUR', value: 'Every hour' },
  { period: 'EVERY_DAY', value: 'Once a day (at 8.00)' }
]

export const EmailSubscriptionMenu: FC<EmailSubscriptionMenuProps> = ({
  selectedPeriod,
  onSubscribeTopicEmails
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        disabled={selectedPeriod === undefined}
        id="email-notifications"
        aria-controls={open ? 'email-notifications-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ border: '1px solid' }}
        color={selectedPeriod === null ? 'default' : 'success'}
        size="medium"
      >
        <>
          {selectedPeriod === null ? (
            <NotificationsOffOutlined fontSize="small" />
          ) : (
            <Notifications fontSize="small" />
          )}
          <ArrowDropDown
            fontSize="small"
            sx={{
              position: 'absolute',
              right: -5,
              backgroundColor: 'background.paper',
              padding: 0,
              width: 15,
              height: 15
            }}
          />
        </>
      </IconButton>
      <Menu
        id="email-notifications-menu"
        MenuListProps={{
          'aria-labelledby': 'email-notifications'
        }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={open}
        onClose={handleClose}
      >
        <Typography variant="body1" sx={{ pl: 2, pr: 2, fontWeight: 500 }}>
          Email notifications
        </Typography>
        <Typography variant="body2" sx={{ pl: 2, pr: 2, pt: 0.5 }}>
          Get notified about new unmoderated comments in this topic
        </Typography>
        <Divider sx={{ mb: 1, mt: 1 }} />
        {options.map(({ period, value }) => (
          <MenuItem
            disabled={selectedPeriod === undefined}
            key={value}
            selected={period === selectedPeriod}
            onClick={async () => {
              await onSubscribeTopicEmails(period)
              setTimeout(() => handleClose(), 100)
            }}
          >
            <ListItemIcon>{period === selectedPeriod && <Check />}</ListItemIcon>
            {value}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
